// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3lEij","bigColWidth":"Table_bigColWidth__IyN-o","biggerColWidth":"Table_biggerColWidth__2GW75","row":"Table_row__Nkalm","col":"Table_col__2ZO_d"};